import useClickOutside from "@/hooks/useClickOutside";
import useFilterAreas from "@/hooks/useFilterAreas";
import React, { useRef } from "react";

const AreaTypes = ({
  refOne,
  destinations,
  setShowAreas,
  areas,
  setAreas,
  setArea,
  setFilterForm,
}) => {
  const refTwo = useRef(null);

  const { renderItems } = useFilterAreas(
    setFilterForm,
    setArea,
    areas,
    setAreas,
  );

  const handleClickOutSide = () => {
    setShowAreas && setShowAreas(false);
  };

  useClickOutside([refOne, refTwo], handleClickOutSide);
  return (
    <div
      ref={refTwo}
      className={`scroll h-[calc(100%-162px)] overscroll-contain lg:max-h-80 overflow-auto font-work font-medium text-sm text-dark-main pr-5`}
    >
      {renderItems(destinations)}
    </div>
  );
};

export default AreaTypes;
